'use strict';

DoohApps
.factory('ClientSoftware', ['restApi', function (restApi) {
    var controllerName = 'ClientSoftware/';

    return {
        getClientSoftwareList: function (successCallback, objectFilterOptions) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetClientSoftwareList', objectFilterOptions);
        },
        getClientSoftware: function (successCallback, objectFilterOptions) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetClientSoftware', objectFilterOptions);
        },
        getDownloadUrl: function (successCallback, objectFilterOptions) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetDownloadUrl', objectFilterOptions);
        },
        getLatestVersion: function (successCallback) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetLatestVersion');
        },
        getDownloadUrlByID: function (successCallback, fileID) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetFileUrl?fileID='+ fileID);
        },
    }
}]);
